import script from "./ShiftModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftModal.vue?vue&type=script&setup=true&lang=ts"

import "./ShiftModal.vue?vue&type=style&index=0&id=5727e71e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5727e71e"]])

export default __exports__